import gsap from 'gsap'

export const initImageRow = () => {
	const isTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches
	const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
	const isMobile = window.innerWidth < 1024
	
	if (isTouch || reduceMotion || isMobile) return

	const rows = document.querySelectorAll('[data-image-row]')
	if (!rows.length) return

	const clamp = (v, min, max) => (v < min ? min : v > max ? max : v)
	const mouse = { x: window.innerWidth / 2 }
	let hasPointer = false

	const heightFromDistance = (dist, minHeight, maxHeight, range) => {
		if (dist >= range) return minHeight
		const t = 1 - dist / range
		return minHeight + (maxHeight - minHeight) * t
	}

	window.addEventListener(
		'pointermove',
		(e) => {
			hasPointer = true
			mouse.x = e.pageX
		},
		{ passive: true }
	)

	window.addEventListener('blur', () => {
		hasPointer = false
	})

	rows.forEach((row) => {
		const images = [...row.querySelectorAll('[data-image-row-image]')]
		if (!images.length) return

		const maxHeight = Number.parseFloat(row.dataset.maxHeight) || 700
		const minHeight = Number.parseFloat(row.dataset.minHeight) || 300
		let isInView = false

		const imageData = images.map((image) => ({
			el: image,
			cx: 0,
			setHeight: gsap.quickTo(image, 'height', {
				duration: 0.8,
				ease: 'power2.out',
				overwrite: 'auto',
			}),
		}))

		const calculatePositions = () => {
			const rowRect = row.getBoundingClientRect()
			const dynamicRange = rowRect.width / Math.max(images.length - 1, 1)
			const range = Number.parseFloat(row.dataset.range) || dynamicRange * 0.95

			for (let i = 0; i < imageData.length; i++) {
				const rect = imageData[i].el.getBoundingClientRect()
				imageData[i].cx = rect.left + rect.width / 2 + window.scrollX
				imageData[i].range = range
			}
		}

		const resetHeights = () => {
			for (let i = 0; i < imageData.length; i++) {
				imageData[i].setHeight(minHeight)
			}
		}

		calculatePositions()
		resetHeights()

		window.addEventListener('resize', calculatePositions, { passive: true })

		if ('ResizeObserver' in window) {
			const observer = new ResizeObserver(calculatePositions)
			observer.observe(row)
			imageData.forEach((data) => observer.observe(data.el))
		}

		if ('IntersectionObserver' in window) {
			const inViewObserver = new IntersectionObserver(
				(entries) => {
					const entry = entries[0]
					isInView = entry.isIntersecting
					if (!isInView) resetHeights()
				},
				{ threshold: 0.05 }
			)
			inViewObserver.observe(row)
		} else {
			isInView = true
		}

		gsap.ticker.add(() => {
			if (!hasPointer || !isInView) return

			for (let i = 0; i < imageData.length; i++) {
				const data = imageData[i]
				const dist = Math.abs(mouse.x - data.cx)
				const height = heightFromDistance(dist, minHeight, maxHeight, data.range)
				data.setHeight(clamp(height, minHeight, maxHeight))
			}
		})
	})
}